import { render, staticRenderFns } from "./userHeader.vue?vue&type=template&id=2b565973"
import script from "./userHeader.vue?vue&type=script&lang=js"
export * from "./userHeader.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/login/userHeader.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports